export enum BoardView {
  Status = 0,
  Technician = 1,
  Priority = 2,
}
